import React from 'react';
import { CssBaseline } from '@mui/material';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { DefaultRoutes } from './Pages/Layout/routes';
import Layout from './Pages/Layout/layout';

function App() {
  return (
    <BrowserRouter>
      <CssBaseline />
      <Routes>
        {DefaultRoutes.map((route) => (
          <Route key={route.path} path={route.path} element={<Layout>{route.element}</Layout>}>
            {route.children &&
              route.children.map((child) => (
                <Route
                  key={child.path}
                  path={child.path}
                  element={child.element}
                />
              ))}
          </Route>
        ))}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
